import { useCallback, useEffect, useState } from "react"

import { EventModal } from "@/components/EventModal"
import { GalleryModal } from "@/components/GalleryModal"
import { GuideOverlay } from "@/components/GuideOverlay"
import { LetterModal } from "@/components/LetterModal"
import { MapSelectModal } from "@/components/MapSelectModal"
import { MapView } from "@/components/MapView"
import { ProgressBar } from "@/components/ProgressBar"
import RecallEntry from "@/components/RecallEntry"
import { ShareModal } from "@/components/ShareModal"
import { SkinModal } from "@/components/SkinModal"
import { guideConfig } from "@/data/guide"
import { useGalleryStore, useGuideStore, useModalStore } from "@/store"

import styles from "./index.module.scss"

export const MainGame = () => {
    const [mapSelectOpen, setMapSelectOpen] = useState(false)

    const guideStore = useGuideStore()
    const galleryStore = useGalleryStore()

    const openGallery = useModalStore((state) => state.openGallery)

    useEffect(() => {
        galleryStore.initGallery()
        if (!guideStore.isGuideDone()) {
            guideStore.initGuide(guideConfig)
        }
    }, [galleryStore.initGallery, guideStore.isGuideDone, guideStore.initGuide])

    const handleOpenMapSelect = useCallback(() => setMapSelectOpen(true), [])
    const handleCloseMapSelect = useCallback(() => setMapSelectOpen(false), [])

    return (
        <div className={styles.mainGame}>
            <MapView
                onOpenMapSelect={handleOpenMapSelect}
                onOpenGallery={openGallery}
                progressSlot={<ProgressBar />}
            />

            <RecallEntry />

            <EventModal />

            <MapSelectModal
                open={mapSelectOpen}
                onCancel={handleCloseMapSelect}
            />

            <GalleryModal />
            <ShareModal />
            <SkinModal />
            <LetterModal />

            <GuideOverlay />
        </div>
    )
}
